import React, { useState, useEffect } from "react"

import {
  Card,
  CardBody,
  Col,
  Row,
  CardTitle,
  Alert,
  Label,
  Input,
  Button,
  Modal,
  ModalBody
} from "reactstrap"

import { AvForm, AvField, AvRadioGroup, AvRadio } from "availity-reactstrap-validation"
import { post, put, get } from '../../helpers/api_helper';
import Utils from '../Utility';
import { toast } from 'react-toastify';

const AddLeadForm = (props) => {
  const { user, data, role, loading, setLoading } = props;

  async function handleValidSubmit(event, values) {
    console.log('values from form', values, data);
    if (user) {
      const body = {
        ...values,
        token: user?.token,
        slotId: props?.currentSlot?._id,
        date: props?.selectedDate
      };
      await props?.socket.emit('add', body);
    } else {
      toast.error('Unauthorized!');
    }
  }

  return (
    <React.Fragment>
      <div className="">
        <Row>
          <Col>
            <Card>
              <CardBody>
                <div className="">
                  <div className="d-flex" style={{ marginLeft: 'auto' }}>
                    <div>
                      <CardTitle className="h4">{data ? 'Update' : 'Add New'} {role}</CardTitle>
                      <p className="card-title-desc">
                        This <code>{role}</code> Will be added to your <code>Slot {props?.currentSlot?.startAt}-{props?.currentSlot?.endAt}.</code>
                      </p>
                    </div>
                    <div className="text-center" style={{ marginLeft: 'auto' }}>
                      <Button color="primary" onClick={() => { props?.close(false) }} style={{ background: `linear-gradient(135deg, ${Utils.themeColor} 0%, #8b0000 100%)`, border: 'none' }}>
                        Close
                      </Button>
                    </div>
                  </div>
                  <AvForm
                    className="form-horizontal"
                    onValidSubmit={(e, v) => {
                      handleValidSubmit(e, v)
                    }}
                  >
                    <div className="form-group mb-4">
                      <AvField
                        name="name"
                        label={"Patient Name"}
                        value={data?.name}
                        className="form-control"
                        placeholder={`Enter Patient Name`}
                        type="text"
                        required
                      />
                    </div>
                    <div className="form-group mb-4">
                      <AvField
                        name="mobile"
                        label={"Mobile Number"}
                        value={data?.mobile}
                        className="form-control"
                        placeholder={`Enter Mobile e.i (9876543210)`}
                        type="number"
                        required
                        validate={{ maxLength: { value: 10 }, minLength: { value: 10 } }}
                      />
                    </div>
                    <div className="form-group mb-4">
                      <span>Gender</span>
                      <AvRadioGroup name="gender" required errorMessage="Pick one!">
                        <div className="d-flex justify-content-around mt-2">
                          <AvRadio label="Male" value="Male" />
                          <AvRadio label="Female" value="Female" />
                          <AvRadio label="Other" value="Prefer not to say" />
                        </div>
                      </AvRadioGroup>
                    </div>
                    <div className="form-group mb-4">
                      <AvField
                        name="address"
                        label={"Address"}
                        value={data?.address}
                        className="form-control"
                        placeholder={`Enter Address`}
                        type="text"
                        required
                      />
                    </div>
                    {/* <AvField name="idx" value={user?.company._id} type="hidden" /> */}
                    <div className="text-center mt-4">
                      {data ?
                        <Button type="submit" color="primary" style={{ background: `linear-gradient(135deg, ${user?.company?.theme ? user?.company?.theme : Utils.themeColor} 0%, #8b0000 100%)`, border: 'none' }}>
                          Update {props.role}
                        </Button>
                        :
                        <Button type="submit" color="primary" style={{ background: `linear-gradient(135deg, ${user?.company?.theme ? user?.company?.theme : Utils.themeColor} 0%, #8b0000 100%)`, border: 'none' }}>
                          Add {props.role}
                        </Button>
                      }
                    </div>
                  </AvForm>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </React.Fragment>
  )
}

export default AddLeadForm;
